import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["date", "submit"]; }

  // bootstrap-datepicker announces a picked date with jQuery's `.trigger("change")`, which no
  // addEventListener ever sees, so a `change->` data-action here would be dead.
  connect() {
    this.syncSubmit();
    $(this.dateTarget).on("change.adminReminders", () => this.syncSubmit());
  }

  disconnect() {
    $(this.dateTarget).off("change.adminReminders");
  }

  syncSubmit() {
    this.submitTarget.disabled = !this.dateTarget.value;
  }

  // Plain form.submit(): this form carries no lt-single-submit and nothing binds a jQuery submit
  // handler to it (see admin_redeemed_gift_controller.js for the same reasoning), so jQuery's
  // .submit() shorthand and the native method behave identically here.
  submit() {
    this.submitTarget.disabled = true;
    this.element.submit();
  }
}
